import { setData, getData, deleteData } from "@/lib/indexed-db";

export class GameManager {
  static async handleEvent(gameId: string, event: any) {
    const { type, data } = event;
    let result = null;
    switch (type) {
      case "save":
        result = await GameManager.saveData(gameId, data);
        break;
      case "load": {
        result = await GameManager.loadData(gameId);
        break;
      }
      case "delete":
        result = await GameManager.deleteData(gameId);
        break;
    }
    return {
      type,
      ...result,
    };
  }
  static async saveData(gameId: string, data: any) {
    try {
      await setData("games", gameId, data);
      return { success: true };
    } catch (error) {
      console.error("Failed to save game data:", error);
      return { success: false, message: "게임 데이터 저장 실패" };
    }
  }

  static async loadData(gameId: string) {
    try {
      const result = await getData("games", gameId);
      return { success: true, data: result?.data ?? null };
    } catch (error) {
      console.error("Failed to load game data:", error);
      return { success: false, message: "게임 데이터 불러오기 실패" };
    }
  }

  static async deleteData(gameId: string) {
    try {
      await deleteData("games", gameId);
      return { success: true };
    } catch (error) {
      console.error("Failed to delete game data:", error);
      return { success: false, message: "게임 데이터 삭제 실패" };
    }
  }
}
